import { useEffect, useState } from 'react';

export function useHydratedForm(source, mapFn) {
  const [form, setForm] = useState(() =>
    source ? mapFn(source) : {}
  );

  useEffect(() => {
    if (source) {
      setForm(mapFn(source));
    }
  }, [source, mapFn]);

  return [form, setForm];
}